"use strict";

var _interopRequireWildcard = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countFocus = countFocus;
exports.getAttentionList = getAttentionList;
exports.getRoleList = getRoleList;
exports.saveAttention = saveAttention;
exports.switchRole = switchRole;
exports.updateDefaultRole = updateDefaultRole;
var _request = _interopRequireDefault(require("@/utils/request"));
var _DaoServiceClientES6Adapter = _interopRequireWildcard(require("@/utils/daoService/DaoServiceClientES6Adapter"));
var attention = _DaoServiceClientES6Adapter.default.QSysVesselFollowNot.using(_DaoServiceClientES6Adapter.dsc);
/* 查询 */
function getAttentionList(data) {
  data.currentPage = 1;
  data.pageSize = 999999;
  return new Promise(function (resolve, reject) {
    _DaoServiceClientES6Adapter.dsc.customCommand('focusVessel').tag('getFocus').paging(data.currentPage, data.pageSize).execute(data, function (res) {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}
/* 查询 */
function countFocus(data) {
  return new Promise(function (resolve, reject) {
    _DaoServiceClientES6Adapter.dsc.customCommand('countFocus').tag('countFocus').execute(data, function (res) {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}

/* 保存 */
function saveAttention(data) {
  return attention.save(data);
}

/* 获取用户角色列表 */
function getRoleList() {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysRole/getCurrentUserSysRoleList',
    method: 'GET'
  });
}
/* 切换用户角色列表 */
function switchRole(params) {
  return (0, _request.default)({
    url: '/sitceb-authentication/switch/role',
    method: 'POST',
    params: params
  });
}
/* 修改用户默认角色 */
function updateDefaultRole(data) {
  return (0, _request.default)({
    url: '/sitceb-authentication/switch/updateDefaultRole',
    method: 'post',
    data: data
  });
}